import Marquee from "react-fast-marquee";

const ITEMS = [
  "Detailed Workmanship",
  "Reliable Service",
  "Eco-Conscious Options",
  "Transparent Estimates",
  "Serving All NYC",
  "Personalized Care",
  "Secure Payments",
];

export const EditorialMarquee = () => (
  <div className="bg-[#050505] border-y border-white/10 py-6 md:py-8">
    <Marquee speed={40} gradient={false} autoFill>
      {ITEMS.map((t, i) => (
        <div key={i} className="flex items-center">
          <span className="font-display italic text-2xl md:text-4xl text-zinc-200 px-6 md:px-10">
            {t}
          </span>
          <span className="text-gold text-xl md:text-2xl">✦</span>
        </div>
      ))}
    </Marquee>
  </div>
);
